import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router'

import CheckView from '../views/experience/CheckconnectionView.vue'





import ReviewVideo from '../views/reviewVideo/reviewVideoView.vue'


import CheckMission from '../views/checkmission/CheckMissionView.vue'

import WellCome from '../views/wellcome/WellcomeUserView.vue'
import ConnectDevice from '../views/wellcome/ConnectDeviceView.vue'

import History from '../views/histories/histories.vue'

// import ScanConnect from '../views/scanconnect/ScanConnectView.vue'
import SpeedTest from '@/views/bot-manager/speed.vue'
import SlientLogin from '@/views/slient-login/silent-check-sso.vue'
import UAParser from 'ua-parser-js'
import MissionOperationView from '../views/missionOperation/MissionOperationView.vue'
var parser = new UAParser(); 
// debugger;
export const routes = [
  // {
  //   path: '/',
  //   name: 'checkmission',
  //   component: CheckMission
  // },
  {
    path:'/slient-login',
    name:"slient-login",
    component:SlientLogin 
  },
  {
    path: '/',
    name: 'WellCome',
    component: (parser.getDevice().type=='mobile' ?  History:WellCome)
  },
  {
    path: '/connectdevice',
    name: 'ConnectDevice',
    component: ConnectDevice
  },
  {
    path: '/scandevice',
    name: 'ScanConnect',
    // component: ScanConnect
    component: () => import(/* webpackChunkName: "scan-connect" */ '../views/scanconnect/ScanConnectView.vue')
  },
  {
    path: '/experience', 
    name: 'experienceview',
    // component: ()=> ExperienceView
    component: () => import(/* webpackChunkName: "experienceview" */'../views/experience/ExperienceView.vue')
  },
  // {
  //   path:'/history',
  //   name:'histories',
  //   component:()=>import(/* webpackChunkName: "histories" */ "../views/histories/histories.vue")
  // },
  {
    path: '/checkconnection',
    name: 'checkconnect1',
    component: CheckView
    // component: () => import(/* webpackChunkName: "checkconnect1" */'../views/experience/CheckconnectionView.vue')
  },
  {
    path: '/msdev',
    name: 'msdev',
    // component: MsDev
    component: () => import(/* webpackChunkName: "msdev" */'../views/experience/msdev.vue')
  },
  {
    path: '/remote',
    name: 'remote',
    component: () => import(/* webpackChunkName: "remote" */'../views/experience/remote.vue')
  },
  {
    path: '/obstacles',
    name: 'obstacles',
    component: () => import(/* webpackChunkName: "obstacles" */'../views/obstacles/obstacles.vue')
  },
  // #576: /mars, /checkconnectionmars, /competition, /checkconnectioncompetition,
  // /reviewcompetition and /listvideo were removed with their views (backup: tag
  // archive/mars-competition-576). Experience keeps its mars field.

  {
    path: '/gateway',
    name: 'gateway',
    component: ()=>import(/* webpackChunkName: "gateway"*/ '../views/gateway/GatewayView.vue')
  },
  {
    path: '/review',
    name: 'reviewvideo',
    component: ReviewVideo
  },
  {
    path: '/speed',
    // name: 'listVideo',
    component: SpeedTest
  },
  {
    path: '/mission-operation',
    name: 'missionOperation',
    component: MissionOperationView
  },
  
  
  // {
  //   path: '/checkmissionexperience',
  //   name: 'checkmission',
  //   component: CheckMission
  // },
  
]


// const router = createRouter({
//   history: createWebHashHistory(),
//   routes
// })

const router = createRouter({
  history: createWebHistory(), 
  routes: routes,
  linkActiveClass: 'active'
});

export default router


